import { useManager } from 'dreamstate';

import { useIsStaff } from '@vimeo/core/hooks/use-is-staff/useIsStaff';
import { Maybe } from '@vimeo/core/types/generic';

import { DebugControlManager, IDebugControlContext } from './DebugControlManager';
import { environmentConfig } from '../../configs/EnvironmentConfig';

/**
 * Check the availability of the debug tools in the current context.
 * It is not strictly limited in CI/DEV env.
 *
 * For production environment it requires:
 *  - enabled debugging
 *  - being staff user if the current environment is production
 *
 * @returns whether in current context user can see the debug tools
 */
export function useCanSeeDebugTools(): boolean {
  const debugContext: Maybe<IDebugControlContext> = useManager(DebugControlManager);
  const isStaff: boolean = useIsStaff();

  return Boolean(debugContext?.isEnabled && (environmentConfig.IS_DEV || isStaff));
}

/**
 * Check if the user can toggle debug via visual controls.
 * Requires being a staff user or dev environment.
 *
 * @returns whether in current context user can toggle debug mode
 */
export function useCanToggleDebugTools(): boolean {
  const isStaff: boolean = useIsStaff();

  return Boolean(environmentConfig.IS_DEV || isStaff);
}
